export default {
  title: 'Checkout',
};
